module.exports = __webpack_public_path__ + "static/media/cooking-salon-ad5.ebd020cc.jpg";